/**
 * Dashboard for Department Services
 *
 * SECURITY FIX: Converted raw axios calls to makeApiCall for JWT auth.
 */
import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

export const getDashboardForDepartmentData = () => {
	const URL = `${API_URL}DashboardAttendanceDetails`;
	if (process.env.NODE_ENV === 'development') console.log(URL);
	return makeApiCall(URL, {}, 'GET');
};

export const getDashboardForDepartmentAttendanceBySectionwiseData = (
	sectionName: string,
	month: string,
	year: string,
) => {
	const URL = `${API_URL}DashboardAttendanceForHeadOffice`;
	if (process.env.NODE_ENV === 'development') console.log('API URL:', URL);
	if (process.env.NODE_ENV === 'development') console.log('Request params:', { sectionName, currentmonth: month, year });
	/** SECURITY FIX: Use makeApiCall for JWT auth on GET request with query params */
	return makeApiCall(
		`${URL}?sectionName=${encodeURIComponent(sectionName)}&currentmonth=${encodeURIComponent(month)}&year=${encodeURIComponent(year)}`,
		{},
		'GET',
	);
};
